module.exports = __webpack_public_path__ + "static/media/kRAcuvueActive2.eab921ea.png";